/*
 * @Description: 转运调度 api
 * @Author: lidan
 * @Date: 2020-08-19 10:06:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-31 19:39:11
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_BUSI_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB = ""
  // E6-MS-TMS-BUSI-WEB = ""
} = e6ModuleOrderWaybillProcessApi;

//********************* 转运调度 ****************** */

// 获取转运调度列表数据
export function findTransportDispatchByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/list`,
    method: "post",
    data
  });
}

//获取下拉框区域名称
export function getAreaLablePositionTransportDispatch(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}

//导出转运调度列表数据
export function exportTransfer(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/exportTransfer`,
    method: "post",
    data
  });
}
